import { fillInsideRectangle, thresholdInsideRectangle } from './fillRectangle';
import { fillInsideCircle, fillOutsideCircle } from './fillCircle';

export {
  fillInsideRectangle,
  thresholdInsideRectangle,
  fillInsideCircle,
  fillOutsideCircle,
};
